/**
 * @generated SignedSource<<d286ede3f2edeee466a0bd65055c253b>>
 * @relayHash 7555a82a51148c607a64f1ab7402dfed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainVirtualServiceAgentCtaCardQuery } from './mainVirtualServiceAgentCtaCardQuery.graphql';

const node: PreloadableConcreteRequest<mainVirtualServiceAgentCtaCardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a066b2d28ec980806bb63d852e0abfc11a1a1a5c90904f798db2d9030dc7252b",
    "metadata": {},
    "name": "mainVirtualServiceAgentCtaCardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
